import sdl from '@jds/react-generated-sdl/JDSTableBody';
import type { JDSTableBodyProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSTableBodyProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    density = 'undefined',
    columnDivider = false,
    fullWidth = false,
    zebra = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { density, columnDivider, fullWidth, zebra, ...rest },
    'JDSTableBody',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TableBody = withLogic(Component) as React.FC<JDSTableBodyProps> & {
  slotName?: string;
};

TableBody.displayName = 'TableBody';
TableBody.slotName = 'jds_table_body';

export { TableBody, type JDSTableBodyProps };
